module.exports = __webpack_public_path__ + "public/Icons/prevArrowIcon.svg?9de36409";